import { useState } from "react";
import {
  Popper,
  Grow,
  Loading,
  // MenuCustom,
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardContent,
  Paper,
  ClickAwayListener,
  MenuItem,
  MenuList,
  ListStatus
} from "../../components";
// import { history } from "../../services";
import "./list-layout.css";
import { useImportContext } from "../../contexts/import.context";

const ListLayout = ({
  children,
  loading,
  onClickCadastrar,
  title,
  // ButtonMenu,
  buttonSelectOpcoes,
  textoAdicionarCustom,
  permissaoButton = false,
  listaStatus,
}) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { initialCollapses } = useImportContext();

  const handleClick = (descricao) => {
    onClickCadastrar(descricao);
    setOpen(false);
  };

  const handleToggle = (event) => {
    setOpen((prevOpen) => !prevOpen);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    if (anchorEl.current && anchorEl.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  // const voltarInitial = () => {
  //   initialDtos();
  //   initialCollapses();
  //   history.push("/dashboard");
  // };

  return (
    <div className="list-layout-container">
      {/* <MenuCustom ButtonMenu={ButtonMenu} onClickVoltar={voltarInitial} /> */}
      <Card className="list-layout-card">
        <CardHeader
          title={title}
          action={
            <div className="px-2">
              {buttonSelectOpcoes ? (
                <ButtonGroup
                  variant="contained"
                  color="primary"
                  disabled={!permissaoButton}
                >
                  <Button
                    onClick={() => {
                      handleClick();
                      initialCollapses();
                    }}
                    bold
                    fullWidth
                  >
                    {textoAdicionarCustom ?? 'Adicionar'}
                  </Button>
                  <Button
                    size="small"
                    aria-controls={open ? "split-button-menu" : undefined}
                    aria-expanded={open ? "true" : undefined}
                    aria-haspopup="menu"
                    onClick={handleToggle}
                  >
                    <i
                      className="ph-fill ph-caret-down"
                      style={{ color: "#fff", fontSize: 15 }}
                    ></i>
                  </Button>
                </ButtonGroup>
              ) : (
                <Button
                  onClick={() => {
                    handleClick();
                    initialCollapses();
                  }}
                  color="primary"
                  bold
                  fullWidth
                  variant="contained"
                  disabled={!permissaoButton}
                >
                  {textoAdicionarCustom ?? 'Adicionar'}
                </Button>
              )}
            </div>
          }
        />
        <Popper
          className="menu-selecao"
          open={open}
          anchorEl={anchorEl}
          placement="bottom-end"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "center botton"
                    ? "center top"
                    : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList autoFocusItem>
                    {buttonSelectOpcoes.map((option) => (
                      <MenuItem
                        key={option.descricao}
                        disabled={!option.permission}
                        onClick={() => {
                          handleClick(option.descricao);
                          initialCollapses();
                        }}
                      >
                        {option.descricao}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
        <CardContent className="list-layout-card-content">
          <div className="card-content-inner">
            {listaStatus && <ListStatus listaStatus={listaStatus}/>}
            {children}
          </div>
        </CardContent>
      </Card>
      <Loading loading={loading} />
    </div>
  );
};

export default ListLayout;
